interface MapStyler {
  [key: string]: string | number | boolean;
}

const makeVisible = (
  featureType: string,
  elementType: string = 'all',
  extraStylers: MapStyler[] = []
) => ({
  featureType,
  elementType,
  stylers: [{ visibility: 'on' }, ...extraStylers],
});

const visibleFeatures = [
  'poi',
  'poi.business',
  'poi.attraction',
  'poi.government',
  'poi.medical',
  'poi.place_of_worship',
  'poi.school',
  'poi.sports_complex',
  'poi.park',
  'transit',
  'transit.station',
  'transit.line',
  'administrative',
  'administrative.neighborhood',
  'road',
  'road.arterial',
  'road.local',
];

export const mapSettings = {
  styles: [
    ...visibleFeatures.map((ft) => makeVisible(ft)),
    makeVisible('poi', 'labels.text', [{ font_size: '12px' }, { weight: 'bold' }]),
    makeVisible('administrative.locality', 'labels', [{ font_size: '14px' }]),
  ],
  clickableIcons: true,
  zoomControl: true,
  mapTypeControl: true,
  mapTypeControlOptions: {
    style: 1,
    position: 3,
    mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain'],
  },
  scaleControl: true,
  streetViewControl: true,
  streetViewControlOptions: { position: 6 },
  rotateControl: true,
  fullscreenControl: true,
  fullscreenControlOptions: { position: 2 },
  gestureHandling: 'auto',
  keyboardShortcuts: true,
  maxZoom: 20,
  minZoom: 3,
  scaleControlOptions: { style: 1 },
};
